import styled from 'styled-components';

type DividerProps = {
  color?: string;
};

const Divider = styled.hr<DividerProps>`
  width: 100%;
  height: 1px;
  margin: 0;
  border: none;
  background-color: ${(props) => props.color ?? 'var(--gray-light)'};
`;

export default Divider;
